export default __webpack_public_path__ + "static/DSC_0042-05d624e04d7f3f9c686cba3502c66ded.jpg";